import { controlledDevicesLeft, controlledDevicesMiddle, controlledDevicesRight } from '~/helpers/fields-description';
import { WirelessSwitch } from '~/models/modules/legrand/WirelessSwitch.model';

export class WirelessSwitch3Buttons extends WirelessSwitch {
    get fieldControlledDevices() {
        return undefined;
    }
    get fieldControlledDevicesLeft() {
        return controlledDevicesLeft(this.controlledDevice(1));
    }
    get fieldControlledDevicesMiddle() {
        return controlledDevicesMiddle(this.controlledDevice(3));
    }
    get fieldControlledDevicesRight() {
        return controlledDevicesRight(this.controlledDevice(2));
    }
}
